// Enums / constants for the Cadence marketplace (v3).

export const PROFILE_TYPES = ["musician", "band", "dj", "venue"];
export const MAX_PROFILES_PER_TYPE = 1;

export const PROFILE_TYPE_LABEL = {
  musician: "Musician",
  band: "Band",
  dj: "DJ",
  venue: "Venue / Event Organizer",
};

export const EXPLORE_CATEGORIES = [
  { key: "all", label: "All" },
  { key: "musician", label: "Musicians" },
  { key: "band", label: "Bands" },
  { key: "dj", label: "DJs" },
  { key: "venue", label: "Venues" },
  { key: "gigs", label: "Gigs" },
];

export const GENRES = [
  "Acoustic", "Afrobeat", "Blues", "Bollywood", "Classical", "Devotional",
  "EDM", "Folk", "Funk", "Fusion", "Hip-hop", "House", "Indie", "Jazz",
  "Latin", "Metal", "Pop", "R&B", "Rock", "Soul", "Techno",
].sort();

export const INSTRUMENTS = [
  "Bass", "Drums", "Flute", "Guitar", "Harmonium", "Keyboard", "Piano",
  "Saxophone", "Sitar", "Tabla", "Trumpet", "Violin", "Vocals",
].sort();

export const GIG_TYPES = [
  "Café / Restaurant", "College / University", "Club / Nightlife", "Concert",
  "Corporate Event", "Festival", "Hotel", "Private Party", "Religious Event",
  "Wedding",
].sort();

export const BAND_GROUP_TYPES = ["Acoustic Group", "Band", "Choir", "Ensemble", "Orchestra"];

export const VENUE_TYPES = [
  "Bar", "Café", "Club", "Community Space", "Concert Venue", "Event Organizer",
  "Event Venue", "Hotel", "Lounge", "Restaurant", "Resort", "Rooftop Lounge",
].sort();

export const OPPORTUNITY_TYPES = [
  { key: "gig", label: "Gig" },
  { key: "concert", label: "Concert" },
  { key: "wedding", label: "Wedding" },
  { key: "corporate_event", label: "Corporate Event" },
  { key: "private_event", label: "Private Event" },
  { key: "festival", label: "Festival" },
];

export const REQUIRED_TALENT = ["Band", "DJ", "Instrumentalist", "Musician", "Singer"];

export const APP_STATUS = ["pending", "accepted", "rejected", "completed"];

export const APP_STATUS_LABEL = {
  pending: "Pending",
  accepted: "Accepted",
  rejected: "Rejected",
  completed: "Completed",
};

/** Only Venue / Event Organizer and Band can post gigs. */
export const CAN_POST_GIG_TYPES = ["venue", "band"];
